import LateralMenuElement from "./lateral-menu-element/LateralMenuElement";

type section = "inspections" | "checklist";

const appSections = ["inspections", "checklist"];

const LateralMenu = () => {
  return (
    <div className=" shrink-0 h-full bg-[#F4F4F4] min-w-[75px] border-r border-[#DDDDDD]">
      <div className="w-full flex flex-col justify-center py-5">
        {appSections.map((appSection, index) => (
          <LateralMenuElement
            key={`lateral-${appSection}`}
            section={appSection as section}
            index={index}
          />
        ))}
      </div>
    </div>
  );
};

export default LateralMenu;
